import React from "react";
import "./Orders.css";
import { useTheme } from "@mui/material/styles";
import { Button, Container, CssBaseline, Typography } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import InfiniteTable from "../../components/InfiniteTable/InfiniteTable";
import { useSelector } from "react-redux";

const columns = [
  { id: "id", editable: "/order", editablePk: "id", label: "Order ID" },
  {
    id: "company_location",
    label: "Company",
  },
  {
    id: "customer",
    label: "Username",
  },
  {
    id: "status_label",
    label: "Status",
  },
  {
    id: "created_date",
    label: "Created Date",
  },
  {
    id: "delivery_date",
    label: "Delivery Date",
  },
  {
    id: "total",
    label: "Total Price",
  },
  {
    id: "invoice_total",
    label: "Invoice Total",
  },
  {
    id: "picking_complete",
    label: "Picking Complete",
    align: "center",
  },
  {
    id: "paid_status",
    label: "Paid Status",
    align: "center",
  },
];

export const Orders = (props) => {
  const theme = useTheme();
  const history = useHistory();

  const currentUserStore = useSelector((state) => state.current_user);

  return (
    <>
      <CssBaseline />
      <Container style={{ textAlign: "right", marginBottom: theme.spacing(3) }}>
        {currentUserStore && currentUserStore.is_staff ? (
          <Link
            to="/orders/picklist"
            style={{ marginRight: "10px", textDecoration: "none" }}
            color="secondary"
          >
            <Button variant="contained" color="primary">
              <Typography variant="subtitle2" className="text-white">
                Pick List
              </Typography>
            </Button>
          </Link>
        ) : (
          <></>
        )}
        {/* <Link
          to="/orders/add"
          style={{ textDecoration: "none" }}
          color="secondary"
          className="create-order-button"
        > */}
        <Button
          variant="contained"
          color="primary"
          onClick={() => history.push("/orders/add")}
          className="create-order-button"
        >
          <Typography variant="subtitle2" className="text-white">
            Create Orders
          </Typography>
        </Button>
        {/* </Link> */}
      </Container>
      <Container>
        <InfiniteTable
          {...props}
          apiep="orders"
          columns={columns}
          // data={data}
          dataMapByColumn="id"
          deletable={false}
          editable={true}
          filterable={true}
          label="Orders"
          fetchingModal={null}
        />
      </Container>
    </>
  );
};

export default Orders;
